/**
 * MY — Extension of Time (Section 259(2), M32015) Register Detail 매핑.
 */
import { registerRegisterDetail } from '@/features/startTask/preset_task/shared/preset/register/registerDetailRegistry';

registerRegisterDetail('M32015', {
  title: 'Extension of Time (Section 259(2)) Details',
  fields: [
    { label: 'Company Name', key: ['entityName', 'companyName', 'company_name', 'presetForm.companyName', 'presetForm.state.values.company_name'] },
    { label: 'Registration No.', key: ['entityRegNo', 'companyRegistrationNo', 'presetForm.companyRegistrationNo', 'presetForm.state.values.company_registration_no'] },
    { label: 'Financial Year End', key: ['presetForm.financialYearEnd', 'presetForm.state.values.financial_year_end', 'financial_year_end'] },
    { label: 'Extension Reason', key: ['presetForm.extensionReason', 'presetForm.state.values.extension_reason', 'extension_reason'] },
    { label: 'Resolution Date', key: ['presetForm.dcrDate', 'presetForm.state.values.dcr_date', 'dcr_date'] },
    { label: 'Declaration Date', key: ['presetForm.declarationDate', 'presetForm.state.values.declaration_date', 'declaration_date'] },
  ],
});
